import { AnyChart } from '@d3fc/d3fc-chart';
import {
    postfixNumber,
    postfixNumberWithFixedPrecision,
} from '@instinet-analytics/core-lib';
import { VolumeCapsuleData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import { safeCalculatePercent } from 'utils/percent';

export function renderXAxis(
    chart: AnyChart,
    chartData: VolumeCapsuleData,
    showQuantitiesOnScale: boolean
) {
    if (showQuantitiesOnScale) {
        formatQuantities(chart, chartData);
    } else {
        formatPercentages(chart, chartData);
    }
}

function formatQuantities(chart: AnyChart, chartData: VolumeCapsuleData) {
    chart.xTickFormat((d: number) => {
        if (d === 0) {
            return undefined;
        }
        const maxUnit = postfixNumber(chartData.maxX).slice(-1);
        return postfixNumberWithFixedPrecision(d, 1, maxUnit);
    });
    chart.xTicks(6);
}

function formatPercentages(chart: AnyChart, chartData: VolumeCapsuleData) {
    const { adv, maxX } = chartData;

    const toPercent = (value: number) => safeCalculatePercent(value, adv);
    const fromPercent = (value: number) => (value * adv) / 100;
    const maxPercent = toPercent(maxX);
    chart.xTickFormat((d: number) => {
        if (d === 0) {
            return undefined;
        }
        return Math.round(toPercent(d)) + '%';
    });

    if (maxPercent < 50 || maxPercent > 200) {
        chart.xTicks(6);
        return;
    }

    const interval = maxPercent > 150 ? 50 : 25;
    const ticks: number[] = [];
    for (let tick = 0; tick <= maxPercent; tick = tick + interval) {
        ticks.push(fromPercent(tick));
    }

    chart.xTickValues(ticks);
}
